import {createSlice} from "@reduxjs/toolkit";
import {apiCall} from "./apiAction";

const slice = createSlice({
    name: 'delivery',
    initialState: {
        delivery_products: [], delivery_regions: [], delivery_user_products: [],
        user: {}, message: false
    },
    reducers: {
        getDelivery: (state, action) => {
            state.delivery_products = action.payload
        },
        getDeliveryUserProducts: (state, action) => {
            state.delivery_user_products = action.payload
        },
        getDeliveryRegionsAll: (state, action) => {
            state.delivery_regions = action.payload
        },
        getUser: (state, action) => {
            state.user = action.payload[0]
        },
        saveDelivery: (state, action) => {
            state.delivery_products = state.delivery_products.filter(
                item => item.id !== action.payload.id
            );
            state.message = true
        },
        editDelivery: (state, action) => {
            state.delivery_products = state.delivery_products.filter(item => item.id === action.payload.id ? action.payload : item)
            state.message = true
        },
        messageReset: (state, action) => {
            state.message = false
        },
        messageFail: (state, action) => {
            state.message = 'error'
        }
    }
})

export const getAllDelivery = (region) => apiCall({
    url: "tash-delivery/?region=" + region,
    method: 'GET',
    onSuccess: slice.actions.getDelivery.type
})

export const getAllDeliveryUserProducts = (user) => apiCall({
    url: "tash-delivery/?user=" + user,
    method: 'GET',
    onSuccess: slice.actions.getDeliveryUserProducts.type,
    onFail: slice.actions.messageFail.type,
})

export const deliverySave = (data) => apiCall({
    url: 'tash-delivery/' + data['id'] + '/',
    method: 'PATCH',
    onSuccess: slice.actions.saveDelivery.type,
    onFail: slice.actions.messageFail.type,
    data,
})

export const getDeliveryRegions = () => apiCall({
    url: 'tash-regions/',
    method: 'GET',
    onSuccess: slice.actions.getDeliveryRegionsAll.type,
    onFail: slice.actions.messageFail.type
})

export const getCabinetUser = (id) => apiCall({
    url: 'cabinet-user/?user_id=' + id,
    method: 'GET',
    onSuccess: slice.actions.getUser.type,
    onFail: slice.actions.messageFail.type
})

export default slice.reducer
export const {messageReset} = slice.actions